import { Component, Input, OnInit } from '@angular/core';
import { ContextIdDto } from '@savvy/app';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PhoneNumberHelperService } from 'src/app/flo/shared/services/phone-number-helper.service';
import { UserCurrencyService } from 'src/app/flo/shared/services/userCurrency.service';
import { CreatePetAppointmentV2SyncService } from '../create-pet-appointment-v2-sync.service';
@Component({
  selector: 'app-pet-confirm-appointment-v2',
  templateUrl: './confirm-pet-appointment-v2.component.html',
  styleUrls: ['./confirm-pet-appointment-v2.component.scss']
})
export class ConfirmPetAppointmentV2Component implements OnInit {

  @Input() pickupRequired = false;
  @Input() contextIdDto: ContextIdDto;
  destroy$ = new Subject();

  currencyCode = 'GBP';

  constructor(
    private sharedService: PhoneNumberHelperService,
    public createPetAppointmentV2SyncService: CreatePetAppointmentV2SyncService,
    private userCurrencyService: UserCurrencyService

  ) { }

  ngOnInit(): void {
    this.getCurrencyCode();
  }

  getCurrencyCode() {
    this.userCurrencyService.getDefaultCurrency(this.contextIdDto)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.currencyCode = res.org.currencyCode ? res.org.currencyCode : this.userCurrencyService.defaultCurrency;
      });
  }

}
